"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AwardRibbonSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var AwardRibbonSVG = function AwardRibbonSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.8 23.66l-3.27-4.45a12.52 12.52 0 01-8.31 5.58l3.54 4.8a1 1 0 00.8.4h.08a1 1 0 00.8-.54l1.81-3.53 3.92-.68a1 1 0 00.63-1.58zM5.47 19.21L2.2 23.66a1 1 0 00.63 1.58l3.91.68 1.8 3.53a1 1 0 00.82.55h.08a1 1 0 00.8-.4l3.54-4.8a12.52 12.52 0 01-8.3-5.59zM25.24 17.48a10.5 10.5 0 10-10.15 5.47 10.6 10.6 0 001.82 0 10.52 10.52 0 008.33-5.47zm-11.61-.1c-.59.3-1 .01-.9-.63l.37-2.78-1.85-2c-.44-.48-.28-.97.37-1.09l2.58-.48 1.26-2.46c.3-.58.78-.58 1.08 0l1.26 2.46 2.59.48c.64.12.8.61.36 1.09l-1.84 2 .37 2.78c.09.64-.32.93-.9.63L16 16.18z"
  }));
};
exports.AwardRibbonSVG = AwardRibbonSVG;
AwardRibbonSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(AwardRibbonSVG);
exports.default = _default;